<template>
  <div>
    <!-- Generator: Adobe Illustrator 24.1.0, SVG Export Plug-In  -->
    <svg
      version="1.1"
      xmlns="http://www.w3.org/2000/svg"
      xmlns:xlink="http://www.w3.org/1999/xlink"
      x="0px"
      y="0px"
      :width="width"
      :height="height"
      viewBox="0 0 607.2 194.8"
      style="enable-background:new 0 0 607.2 194.8;"
      xml:space="preserve"
    >
      <defs />
      <g>
        <path
          class="st0"
          d="M81.2,64.8c-23-8-33.5-13.9-33.5-28.6c0-13.2,10.1-21.6,25.1-21.6c22.9,0,42.6,17.9,48.3,39.1
          c0.6,2.4,2.7,4.1,5.2,4.1c3,0,5.4-2.4,5.4-5.4l0-32.2c0-2.7-1.4-5.1-3.7-6.5C113.3,5.3,93.6,0,71.8,0C30,0,0,22,0,61
          c0,35.5,21.3,51.9,60.6,64.1c23.7,7.7,37.3,13.6,37.3,31.4c0,15.7-13.2,23.7-29.6,23.7c-26.1,0-50.7-19.9-58.7-46.8
          C9,131.3,7.1,130,5,130c-2.7,0-4.9,2.3-4.8,5l1.7,37.6c0.1,2.8,1.6,5.5,4,7c14.9,9.3,35.8,15.2,62.4,15.2c47,0,77.4-23,77.4-63.8
          C145.7,93,123,78.8,81.2,64.8z"
        />
        <path
          class="st0"
          d="M461.4,105L461.4,105c-3.1-0.9-6.3,0.7-7.3,3.5c-7,19.1-16.3,31.2-31.4,37.6c-20.8,8.9-39.8,1.2-53.1-24.7
          l-1.3-2.5c52-32.1,85.1-66.6,68.4-99.1c-9.3-18.1-31.9-26.8-64.4-12.8c-54,23.1-75.6,80.3-62,129.2c-11.5,7.3-23.8,13.2-32.1,15.2
          c-20.6,4.9-39-0.5-54.2-30.2l-2.8-5.5c52-32.1,86.7-63.5,69.9-96.1C281.9,1.6,259.3-7,226.8,6.9c-61.5,26.4-81,97-54.2,149.1
          c18.1,35.1,54.4,47.3,89.4,32.3c19.4-8.3,39-22.3,54.3-36c0.6,1.3,1.2,2.6,1.9,3.9c18.1,35.1,54.4,47.3,89.4,32.3
          c33.6-14.4,51.3-41.1,57.9-77.5C465.9,108.4,464.2,105.8,461.4,105z M227.7,20.6c7.6-3.2,13.9,0.7,18.2,9.1
          c13,25.3,4.8,52.1-28.2,76.1C206.8,72.8,207.9,29.1,227.7,20.6z M373.3,20.8c7.6-3.2,13.9,0.7,18.2,9.1c13,25.3,4.9,53.7-28.2,77.7
          C352.5,74.6,353.4,29.3,373.3,20.8z"
        />
        <path
          class="st0"
          d="M605.5,6.2c-3.6-2.7-8.9-4.4-15.7-4.4c-22,0-34.1,12.9-48.4,53.7V7.7c0-3-2.8-5.2-5.8-4.5l-63.9,15.7
          c-2.1,0.5-3.6,2.4-3.6,4.5c0,0.9,0.3,1.8,0.8,2.6l6.6,10.2c3.2,4.8,4.9,10.5,4.9,16.3v113.4c0,10.1-4.6,13.5-15.7,14.8
          c-2.2,0.3-3.8,2.1-3.8,4.3l0,3.8c0,2.4,1.9,4.3,4.3,4.3h99.2c2.4,0,4.3-1.9,4.3-4.3l0-4c0-2.1-1.6-3.9-3.7-4.2
          c-17.1-2.4-23.7-5.9-23.7-19.9l0-65.7c0-19.7,15-36.2,34.7-38.1c7.2-0.7,14.9-0.8,22.8-0.8h4.9c1.9,0,3.5-1.6,3.5-3.5l0-42.9
          C607.2,8.3,606.6,7,605.5,6.2z"
        />
      </g>
    </svg>
  </div>
</template>

<script>
export default {
  name: 'MainLogo',
  props: {
    width: {
      type: String,
      default: '610px',
    },
    height: {
      type: String,
      default: '195px',
    },
  },
};
</script>

<style lang="scss" scoped>
  .st0{
    fill: #333333;
  }
</style>
